import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import CreateSurveyApiRequest from "../request/CreateSurveyApiRequest";

const CreateSurveyApiService = async (request: CreateSurveyApiRequest): Promise<boolean> => {
  const url = "/forms/";
  const payload = {
    ...request,
    questions: request.questions.map(it => ({
      ...it,
      choices: Object.is(it.question_type, "mcq") ?
        it.choices.map((option, index) =>
        ({ "content": option.content, "order_number": index + 1 })) : []
    }))
  };
  const { data } = await axios.post(url, payload);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useCreateSurveyApiService = () =>
  useMutation<boolean, AxiosError, CreateSurveyApiRequest>(
    CreateSurveyApiService, {
      mutationKey: "CreateSurveyApiService"
    }
  );
export default useCreateSurveyApiService;